import { compose, lifecycle, withProps, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ServicesWrapper from '../components/ServicesWrapper';
import withNotifications from '../../../common/withNotifications';
import { activeShop } from '../../../auth/selectors';
import { STEPS } from '../constants';
import { fetchBrandShops } from '../../shops/actions';
import { getBarbers } from '../../barbers/actions';
import { getAll as getAllBarbers, getByIds as getBarbersByIds } from '../../barbers/selector';
import { getAll as getAllShops } from '../../shops/selectors';
import withRoleIdType from '../../../common/hoc/withRoleIdType';
import { emptyAction, withActionByRole } from '../../../common/helpers/actions';

const setStep = props => (step) => {
  const { redirectUrl } = props;
  const { serviceId } = props.params;
  const stepPostfix = step === STEPS.assignments ? '/assign' : '';

  props.router.push(`${redirectUrl}/${serviceId}${stepPostfix}`);
};

const ServicesWrapperContainer = compose(
  withRouter,
  withNotifications,
  withRoleIdType,
  withProps(ownProps => ({
    step: ownProps.route && ownProps.route.name === 'services.assign' ? STEPS.assignments : STEPS.details,
  })),
  withHandlers({
    setStep,
  }),
  withActionByRole(
    'fetchShopsAndBarbers', getBarbers, emptyAction, fetchBrandShops,
  ),
  connect((state, ownProps) => {
    const shop = activeShop(state);
    const shops = [];

    if (ownProps.roleIdType.type === 'shop' && shop) {
      shops.push({ ...shop, barbers: getAllBarbers(state) });
    }

    if (ownProps.roleIdType.type === 'brand') {
      shops.push(...getAllShops(state)
        .map(brandShop => ({ ...brandShop, barbers: getBarbersByIds(state, brandShop.barbers) })));
    }

    return {
      shop,
      shops,
      activeShop: activeShop(state),
    };
  }),
  lifecycle({
    componentDidMount() {
      this.props.fetchShopsAndBarbers();
    },
  })
)(ServicesWrapper);

export default ServicesWrapperContainer;
